import { render } from "./ClientRegistration.vue?vue&type=template&id=3c1adf0a"
import script from "./ClientRegistration.vue?vue&type=script&lang=js"
export * from "./ClientRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__